export const reports = [{
  id: 'discrete_data_imported',
  name: 'On Import',
  description: 'When any data is imported. Cannot be customized',
},
{
  id: 'discrete_import_exceedance',
  name: 'On Guideline Exceedance',
  description: 'When imported data exceeds selected guidelines. Customize below.',
},
]